import imageCompression from 'browser-image-compression'
import { MAX_QUESTION_IMAGE_DIMENSION, MAX_QUESTION_IMAGE_SIZE_KB } from 'constants/imageUpload'

export const compressImage = async (file: File, maxSizeKB = MAX_QUESTION_IMAGE_SIZE_KB): Promise<File> => {
  try {
    const options = {
      maxSizeMB: maxSizeKB / 1024,
      maxWidthOrHeight: MAX_QUESTION_IMAGE_DIMENSION,
      useWebWorker: true,
      initialQuality: 0.8,
    }

    const compressedFile = await imageCompression(file, options)
    console.log('Compressed size (KB):', (compressedFile.size / 1024).toFixed(2))
    return compressedFile
  } catch (err) {
    console.error('Compression error:', err)
    return file
  }
}
